import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingCodePrefixApi from '@/features/dashboard/bookingCodePrefix/api/bookingCodePrefixApi.ts';
import { bookingCodePrefixApiQueryKeys } from '@/features/dashboard/bookingCodePrefix/api/bookingCodePrefixApi.queryKeys.ts';
import { BookingCodePrefixDto } from '@/features/dashboard/bookingCodePrefix/types/BookingCodePrefixDto.ts';

const useGetBookingCodePrefix = () => {
  return useQuery(getBookingCodePrefixQueryOptions());
};

export const getBookingCodePrefixQueryOptions =
  (): UseQueryOptions<BookingCodePrefixDto> => ({
    queryKey: bookingCodePrefixApiQueryKeys.all(),
    queryFn: () => bookingCodePrefixApi.get(),
    staleTime: 1000 * 60,
  });

export default useGetBookingCodePrefix;
